import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import { DEFAULT_CONNECTION_ID } from '../../../../../connections/connection-config';

function mqttSubscribeNodeCfgPreprocess (value: unknown) {
    const maybeNodeParseResult = baseNodeCfgSchema.safeParse(value);
    if (maybeNodeParseResult.success) {
        const nodeCfg = maybeNodeParseResult.data;
        if (nodeCfg.kind === 'mqttSubscribe') {
            // move topic from controlValues to socketDefaults
            const topicSetInControlValues = typeof nodeCfg.controlValues?.topic === 'string' && nodeCfg.controlValues?.topic;
            const topicSetInSocketDefaults = nodeCfg.socketDefaults?.inputs?.topic;
            if (topicSetInControlValues && !topicSetInSocketDefaults) {
                nodeCfg.socketDefaults = {
                    ...nodeCfg.socketDefaults,
                    inputs: {
                        ...nodeCfg.socketDefaults?.inputs,
                        topic: nodeCfg.controlValues?.topic,
                    },
                };
            }
        }
        return nodeCfg;
    } else {
        return value; // let the next schema produce the error
    }
}

const mqttSubscribeNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('mqttSubscribe'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        autoSubscribe: z.boolean().default(true),
        connectionId: z.string().default(DEFAULT_CONNECTION_ID),
        qos: z.union([
            z.literal(0),
            z.literal(1),
            z.literal(2),
        ]),
    })),
}));
export type MqttSubscribeNodeCfgSchema = z.infer<typeof mqttSubscribeNodeCfgSchema>;

const mqttSubscribeNodeCfgSchemaPreprocessed = z.preprocess(mqttSubscribeNodeCfgPreprocess, mqttSubscribeNodeCfgSchema) as z.ZodType<MqttSubscribeNodeCfgSchema>;
export { mqttSubscribeNodeCfgSchemaPreprocessed as mqttSubscribeNodeCfgSchema };

export const mqttSubscribeNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ resubscribe: 'event' }),
        outputs: () => ({ event: 'event' }),
    },
    dataSockets: {
        inputs: () => ({ topic: 'string' }),
        outputs: () => {
            const ret: Record<'payload', 'varValue'> = {
                payload: 'varValue',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<MqttSubscribeNodeCfgSchema>;
